<template>
  <hic-list-page title="元数据" :entities="entities" :condition="condition" @load="page" keywod-placeholder="名称或编码">
    <template slot="buttons">
      <el-button type="primary" @click="create" size="small" v-if="permission.emr_meta_edit"> <i class="el-icon-plus"></i> 新建 </el-button>
    </template>
    <el-table-column label="操作" width="120" align="center" key="action">
      <template slot-scope="scope">
        <el-button v-if="permission.emr_meta_edit" type="primary" icon="el-icon-edit" title="编辑" size="mini" @click="edit(scope.row)" circle plain />
        <el-popconfirm v-if="permission.emr_meta_delete" title="确定要删除吗?" icon-color="red" @confirm="del(scope.row)" class="left-pad">
          <el-button slot="reference" title="删除" type="danger" plain size="mini" circle icon="el-icon-delete"></el-button>
        </el-popconfirm>
        <el-button v-if="permission.emr_meta_edit" type="primary" icon="el-icon-document-copy" title="复制" size="mini" @click="copy(scope.row)" circle plain class="left-pad" />
      </template>
    </el-table-column>
    <el-table-column label="名称" prop="name" key="name" min-width="80" sortable="custom">
      <template slot-scope="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column label="编码" prop="code" key="code" min-width="80" sortable="custom"> </el-table-column>
    <el-table-column label="分类" prop="category" width="100" align="center" key="shortCode" sortable="custom" :filters="dict.MrApiCategory" :filter-multiple="false" column-key="category">
      <template slot-scope="{ row }">
        {{ row.category | dictText("MrApiCategory") }}
      </template>
    </el-table-column>
    <el-table-column label="排序" prop="seqNo" key="seqNo" width="80" align="center" sortable="custom" />
    <el-table-column label="路径" prop="path" key="path" min-width="200" />
    <el-table-column label="返回值" prop="resultType" width="100" show-overflow-tooltip key="resultType" sortable="custom" :filters="dictEnum.MrApiResultType" :filter-multiple="false" column-key="resultType">
      <template slot-scope="{ row }">
        {{ row.resultType }}
      </template>
    </el-table-column>
    <editor v-model="entity" :visible.sync="showEditor" @ok="page" />
  </hic-list-page>
</template>

<script>
  import store from "@/common/store";
  import { mapGetters } from "sw-hic";
  export default {
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.emr_meta_query) {
        next({
          name: "err",
          params: { err: cfg.errs.NeedPromission },
        });
      } else {
        next();
      }
    },
    beforeRouteLeave(to, from, next) {
      // 导航离开该组件的对应路由时调用
      // 可以访问组件实例 `this`
      this.showEditor = false;
      next();
    },
    components: {
      editor: () => import("./editor"),
    },
    data() {
      return {
        condition: {
          category: null,
          keyword: null,
          sort: "seqNo",
          asc: true,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        searchLoading: false,
        entities: {},
        showEditor: false,
        entity: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "permission", "user"]),
    },
    methods: {
      page() {
        let _this = this;
        this.searchLoading = true;
        this.$api.Api.query(this.condition).then((res) => {
          _this.entities = res;
          _this.searchLoading = false;
        });
      },
      create() {
        let entity = {
          category: this.condition.category,
        };
        this.$set(this, "entity", entity);
        this.showEditor = true;
      },
      edit(row) {
        this.$set(this, "entity", this.$utils.Obj.clone(row));
        this.showEditor = true;
      },
      copy(row) {
        let cp = this.$utils.Obj.clone(row)
        cp.id = null
        cp.code = null
        this.$set(this, "entity", cp);
        this.showEditor = true;
      },
      del(val) {
        this.$api.Api.del(val.id)
          .then((res) => {
            this.page();
            this.$message("删除成功");
          })
          .catch((err) => {
            this.$message(err);
          });
      },
      sortChanged(col) {
        if (!col.order) {
          this.condition.sort = "id";
          this.condition.asc = false;
        } else {
          this.condition.sort = col.prop;
          this.condition.asc = col.order == "ascending";
        }
        this.page();
      },
      filterChanged(options) {
        Object.assign(this.condition, options);
        this.page();
      },
    },
  };
</script>
